import script from "./XYToolModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./XYToolModule.vue?vue&type=script&setup=true&lang=ts"

import "./XYToolModule.vue?vue&type=style&index=0&id=c4b22fb4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4b22fb4"]])

export default __exports__